/**
 * @fileoverview GET handler for the "/deliverability/snds/:app_group_id/latest_event" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { deliverabilitySndsAppGroupIdLatestEvent } from "./constants";
import type { DeliverabilitySndsLatestEventResult } from "./types";
import { isDeliverabilitySndsLatestEventResult } from "./validators";

export const getDeliverabilitySndsLatestEvent = reactQueryFetcherAdapter(
  deliverabilitySndsAppGroupIdLatestEvent,
  (signal: AbortSignal, appGroupId: string): Promise<DeliverabilitySndsLatestEventResult> => {
    return fetch(`/deliverability/snds/${appGroupId}/latest_event`, "GET", {}, { signal });
  },
  isDeliverabilitySndsLatestEventResult
);
